import Countries from './countries-container';

export default Countries;
